export default {
  getRFQ(params) {
    return {
      method: 'GET',
      url: 'admin/rfq',
      params,
    };
  },
  getBookings(params) {
    return {
      method: 'GET',
      url: 'admin/booking',
      params,
    };
  },
  getInvoices(params) {
    return {
      method: 'GET',
      url: 'admin/invoices',
      params,
    };
  },
  getShippers({ params }) {
    return {
      method: 'get',
      url: 'admin/shipper',
      params,
    };
  },
  updateShipper(id, data) {
    return {
      method: 'put',
      url: `admin/shipper/${id}`,
      data,
    };
  },
  changeShipperStatus({ id, active }) {
    return {
      method: 'PATCH',
      url: `admin/shipper/${id}/status`,
      data: { active },
    };
  },
  changeTransporterStatus({ id, active }) {
    return {
      method: 'PATCH',
      url: `admin/transporter/${id}/status`,
      data: { active },
    };
  },
  getTransporters({ params }) {
    return {
      method: 'GET',
      url: 'admin/transporter',
      params,
    };
  },
  updateTransporter(id, data) {
    return {
      method: 'PATCH',
      url: `admin/transporter/${id}`,
      data,
    };
  },
  getConversations(params) {
    return {
      method: 'GET',
      url: 'admin/conversations',
      params,
    };
  },
  getOneConversation({ id, params }) {
    return {
      method: 'GET',
      url: `admin/conversations/${id}`,
      params,
    };
  },
  changeMessage({ id, data }) {
    return {
      method: 'PATCH',
      url: `admin/message/${id}`,
      data,
    };
  },
  deleteMessage({ id }) {
    return {
      method: 'DELETE',
      url: `admin/message/${id}`,
    };
  },
  getAllUsers(params) {
    return {
      method: 'GET',
      url: 'admin/user',
      params,
    };
  },
  getRoles() {
    return {
      method: 'GET',
      url: 'admin/user/roles',
    };
  },
  createAdminUser(data) {
    return {
      method: 'POST',
      url: 'admin/user',
      data,
    };
  },
  updateAdminUser(userId, data) {
    return {
      method: 'PUT',
      url: `admin/user/${userId}`,
      data,
    };
  },
  getJobOptions() {
    return {
      method: 'GET',
      url: 'admin/booking-options',
    };
  },
  updateJobOptions(data) {
    return {
      method: 'PUT',
      url: 'admin/booking-options',
      data,
    };
  },
  getPayments(params) {
    return {
      method: 'GET',
      url: 'admin/payments',
      params,
    };
  },
  getFilters() {
    return {
      method: 'GET',
      url: 'filter',
    };
  },
  createFilter(data) {
    return {
      method: 'POST',
      url: 'filter',
      data,
    };
  },
  deleteFilter(id) {
    return {
      method: 'DELETE',
      url: `filter/${id}`,
    };
  },
  getReportedUsers(params) {
    return {
      method: 'GET',
      url: 'admin/reported-users',
      params,
    };
  },
  updateReport(data) {
    return {
      method: 'PUT',
      url: `admin/reported-users/${data.id}`,
      data,
    };
  },
  getNotes(userId) {
    return {
      method: 'GET',
      url: `admin/notes?userId=${userId}`,
    };
  },
  createNote(data) {
    return {
      method: 'POST',
      url: `admin/notes`,
      data,
    };
  },
  updateNote(data) {
    const { id, content } = data;
    return {
      method: 'PATCH',
      url: `admin/notes/${id}`,
      data: { content },
    };
  },
  deleteNote(noteId) {
    return {
      method: 'DELETE',
      url: `admin/notes/${noteId}`,
    };
  },
};
